import { render, staticRenderFns } from "./CollapseTransition.vue.js?vue&type=template&id=729a946b!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CollapseTransition.vue?vue&type=template&id=729a946b"
import script from "./CollapseTransition.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CollapseTransition.vue?vue&type=script&lang=js"
export * from "./CollapseTransition.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CollapseTransition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports